<template>
  <b-card no-body>
    <b-row class="p-1 align-items-center">
      <b-col>
        <b-row style="flex-wrap: nowrap !important;">
          <b-button :style="$route.name==='DiscountCode' ? 'background: #ed1f24 !important; border-color: #ED1F24 !important;':'background: #EFECEC !important; color: #000000 !important; border-color: #EFECEC !important;'" class="ml-1"
                    @click="$router.push({name: 'DiscountCode'})">
            Mã giảm giá
          </b-button>
          <b-button :style="$route.name==='ReferralCode' ? 'background: #ed1f24 !important; border-color: #ED1F24 !important;':'background: #EFECEC !important; color: #000000 !important; border-color: #EFECEC !important;'" class="ml-1"
                    @click="$router.push({name: 'ReferralCode'})">
            Mã giới thiệu
          </b-button>
          <!-- <b-button @click="$router.push({name: 'ReferralCodeMGM'})" class="ml-1" :style="$route.name==='ReferralCodeMGM' ? 'background: #ed1f24 !important; border-color: #ED1F24 !important;':'background: #EFECEC !important; color: #000000 !important; border-color: #EFECEC !important;'">Mã giới thiệu MGM</b-button> -->
        </b-row>
      </b-col>
      <b-col>
        <h4>Danh sách mã giảm giá</h4>
      </b-col>
      <b-col>
        <b-form-datepicker
            v-model="serverParams.columnFilters.start_date"
            :date-format-options="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }"
            locale="vi-VN"
        />
      </b-col>
      <b-col>
        <b-form-datepicker
            v-model="serverParams.columnFilters.end_date"
            :date-format-options="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }"
            locale="vi-VN"
        />
      </b-col>
      <b-col>
        <b-row style="flex-wrap: nowrap !important;">
          <b-button variant="primary">Xuất Excel</b-button>
          <b-button class="ml-4" variant="primary" @click="()=>{openModal('create');clearForm()}">+ Tạo mã giảm giá
          </b-button>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="pb-1 m-0">
      <b-col cols="12">
        <vue-good-table
            :columns="fields"
            :isLoading.sync="isLoading"
            :line-numbers="true"
            :pagination-options="{
						perPage: serverParams.pageSize,
						enabled: true,
						perPageDropdown: [20, 50, 100],
						dropdownAllowAll: false,
					}"
            :rows="rows"
            :totalRows="totalRecords"
            mode="remote"
            @on-column-filter="onColumnFilter"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChange">

          <template slot="table-row" slot-scope="props">
            <!-- Column: Action -->
            <span v-if="props.column.field === 'action'">
                  <b-dropdown
                      no-caret
                      size="sm"
                      toggle-class="text-decoration-none"
                      variant="link"
                  >
                    <template v-slot:button-content>
                      <feather-icon
                          class="text-body align-middle mr-25"
                          icon="MoreVerticalIcon"
                          size="16"
                      />
                    </template>

                    <b-dropdown-item v-if="props.row.status==='Chưa diễn ra' || props.row.status==='Chưa hoạt động'"
                                     @click="()=>{GetVoucherInfo(props.row,'edit')}">
                      <feather-icon class="mr-50" icon="Edit3Icon"/><span
                    >Sửa mã giảm giá</span
                    >
                    </b-dropdown-item>
                    <b-dropdown-item v-if="props.row.status==='Đã kết thúc' || props.row.status==='Đang diễn ra' || props.row.status==='Dừng hoạt động'"
                                     @click="()=>{GetVoucherInfo(props.row,'view')}">
                      <feather-icon class="mr-50" icon="EyeIcon"/><span
                    >Xem chi tiết</span
                    >
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
            <span v-else-if="props.column.field === 'DeliveryType'">
                  <feather-icon
                      v-if="props.row.DeliveryType == 1"
                      icon="CheckIcon"
                  />
                </span>
            <span v-else-if="props.column.field === 'IsFast'">
                  <feather-icon v-if="props.row.IsFast == 1" icon="CheckIcon"/>
                </span>
            <span v-else-if="props.column.field === 'TotalPrice'">
                  {{ props.formattedRow[props.column.field] | number }}
                </span>
            <span
                v-else-if="
                    props.column.field === 'Phones' && props.row.Phones
                  "
            >
                  <span v-html="props.row.Phones.replace(/,/g, '<br>')"/>
                </span>
            <span v-else-if="props.column.field === 'Id'">
                  <a class="text-primary" @click="view(props.index)">{{
                    props.row.Id
                  }}</a>
                </span>
            <span v-else-if="props.column.field === 'PaymentChannel'">
                  <a class="text">{{
                    props.row.PaymentChannel == "BANKTRANFER"
                      ? "Chuyển khoản"
                      : props.row.PaymentChannel
                  }}</a>
                </span>
            <span v-else-if="props.column.field === 'ECommercePlatform'">
                  <a class="text">{{ props.row.ECommercePlatform }}</a>
                </span>
            <span v-else-if="props.column.field === 'ECommerceNotes'">
                  <a class="text">{{ props.row.ECommerceNotes }}</a>
                </span>
            <span v-else-if="props.column.field === 'GHTK_Id'">
                  <a
                      v-if="
                      props.row && props.row.IsFast == 1 && props.row.J_Shipment
                    "
                      :href="props.row.J_Shipment.shared_link"
                      target="_blank"
                  >{{ props.row.GHTK_Id }}</a
                  >
                  <a
                      v-else-if="props.row.ShippingPartner === 'GHN'"
                      :href="'https://donhang.ghn.vn/?order_code=' + props.row.GHTK_Id"
                      target="_blank"
                  >{{ props.row.GHTK_Id }}</a
                  >
                  <a
                      v-else
                      :href="'https://i.ghtk.vn/' + props.row.GHTK_Id"
                      target="_blank"
                  >{{ props.row.GHTK_Id }}</a
                  >
                </span>
            <span v-else-if="props.column.field === 'Status'">
                  <span class="badge badge-light-info">{{
                    statusList.find((m) => m.id == props.row.Status).text
                  }}</span>
                </span>
            <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
          </template>
        </vue-good-table>
      </b-col>
    </b-row>
    <b-modal id="popupCreateDiscount" hide-footer size="xl" title="Thêm mới mã giảm giá">
      <h2 class="pb-1">Thông tin cơ bản</h2>
      <b-row class="px-1">
        <b-col class="p-0" cols="6">
          <h3 style="color: #000000;">Mã giảm giá <span class='text-danger'>*</span></h3>
          <div class="d-flex pb-2">
            <b-col class="pl-0">
              <validation-provider #default="{ errors }" rules="required|length:3">
                <b-form-input v-model="partnerCode" :disabled="modalType==='view'" :formatter="formatPartnerCode" :state="errors.length > 0 ? false : null"
                              placeholder="Nhập mã đối tác" size="sm1"
                              type='text'/>
                <small v-if="errors.length>0" class="text-danger">Vui lòng nhập mã đối tác</small>
              </validation-provider>
            </b-col>
            <b-col>
              <validation-provider #default="{ errors }" rules="required|length:2">
                <b-form-input v-model="campaignCode" :disabled="modalType==='view'" :formatter="formatCampaignCode"
                              :state="errors.length > 0 ? false : null" class="form-control form-control-sm1" placeholder="Nhập mã CTKM"
                              type="number"/>
                <small v-if="errors.length>0" class="text-danger">Vui lòng nhập mã CTKM</small>
              </validation-provider>
            </b-col>
            <b-col>
              <h3 style="color: #000000; margin-top: -32px;">Số lượng</h3>
              <b-form-input v-model="amount" :disabled="modalType==='view'" placeholder="Nhập số lượng" size="sm1"
                            type="number"/>
            </b-col>
          </div>
          <div class="d-flex mb-2">
            <b-col class="pl-0">
              <validation-provider #default="{ errors }" rules="required">
                <h3 style="color: #000000;">Tên chương trình <span class='text-danger'>*</span></h3>
                <b-form-input v-model="campaignName" :disabled="modalType==='view'" :state="errors.length > 0 ? false : null"
                              placeholder="Nhập tên chương trình" size="sm1"/>
                <small v-if="errors.length>0" class="text-danger">Vui lòng nhập tên chương trình</small>
              </validation-provider>
            </b-col>
          </div>
          <h2 class="pb-2">Thiết lập mã giảm giá</h2>
          <div class="d-flex">
            <b-col class="pl-0">
              <h3 style="color: #000000;">Loại giảm giá <span class='text-danger'>*</span></h3>
              <Select2
                  v-model="discountType"
                  :disabled="modalType==='view'"
                  :options="[
                {id:'0',text:'Giảm theo số tiền'},
                {id:'1',text:'Giảm theo phần trăm'},
                ]"
                  :settings="{allowClear:true}"
                  placeholder="Loại giảm giá"
              />
            </b-col>
            <b-col class="pb-2 pl-0">
              <validation-provider #default="{ errors }" rules="required">
                <h3 style="color: #000000;">Giá trị giảm <span class='text-danger'>*</span></h3>
                <b-form-input v-model="discountAmount" :disabled="modalType==='view'" :state="errors.length > 0 ? false : null" placeholder="Nhập giá trị giảm"
                              size="sm1" type="number"/>
                <small v-if="errors.length>0" class="text-danger">Vui lòng nhập Giá trị giảm</small>
              </validation-provider>
            </b-col>
          </div>
          <div class="d-flex mb-2">
            <b-col class="pl-0">
              <h3 style="color: #000000;">Đơn vị áp dụng <span class='text-danger'>*</span></h3>
              <Select2
                  v-model="usageMethod"
                  :disabled="modalType==='view'"
                  :options="[
                {id:'0',text:'Đơn hàng'},
                {id:'1',text:'Sản phẩm'},]"
                  :settings="{allowClear:true}"
                  placeholder="Hình thức áp dụng mã"
              />
            </b-col>
            <b-col class="pl-0">
              <validation-provider #default="{ errors }" rules="required">
                <h3 style="color: #000000;">Giá trị tối thiểu <span class='text-danger'>*</span>
                  <feather-icon
                      v-b-tooltip.hover.topright="'Nhập giá trị đơn hàng tối thiểu khi chọn đơn vị áp dụng: Đơn hàng, Nhập giá trị sản phẩm tối thiểu khi chọn đơn vị áp dụng: Sản phẩm'"
                      icon="AlertCircleIcon" size="20"/>
                </h3>
                <b-form-input v-model="minOrder" :disabled="modalType==='view'" :state="errors.length > 0 ? false : null" placeholder="Nhập giá trị tối thiểu được áp dụng KM"
                              size="sm1"
                              type="number"/>
                <small v-if="errors.length>0" class="text-danger">Vui lòng Nhập giá trị tối thiểu được áp dụng
                  KM</small>
              </validation-provider>
            </b-col>
          </div>
          <div class="d-flex">
            <h3 class="mr-2">Thiết lập tùy biến</h3>
            <b-form-checkbox v-model="customization" disabled name="check-button" switch/>
          </div>
          <div class="d-flex">
            <b-col class="pl-0">
              <h3 style="color: #000000;">Xử lý</h3>
              <Select2
                  v-model="appointedUser"
                  :disabled="modalType==='view'"
                  :options="selectedData.usersSelected"
                  :settings="{allowClear:true}"
                  placeholder="Xử lý"
              />
            </b-col>
            <b-col class="pb-2">
              <h3 style="color: #000000;">Giao hàng</h3>
              <multiselect
                  v-model="deliveryMethod"
                  :close-on-select="true"
                  :disabled="modalType==='view'"
                  :multiple="true"
                  :options="deliveryMethodList"
                  :show-labels="false"
                  label="text"
                  placeholder="Giao hàng"
                  track-by="id"
              />
            </b-col>
          </div>
          <div class="d-flex">
            <b-col class="pl-0">
              <h3 style="color: #000000;">Xác thực</h3>
              <Select2
                  v-model="verificationMethod"
                  :disabled="modalType==='view'"
                  :options="[
                {id:'0',text:'Không'},
                {id:'1',text:'Email'},
                {id:'2',text:'ZNS'},
                ]"
                  :settings="{allowClear:true}"
                  placeholder="Xác thực"
              />
            </b-col>
            <b-col class="pb-2">
              <validation-provider #default="{ errors }" :rules="verificationMethod==='0'?'':'required|email'">
                <h3 style="color: #000000;">Email/SĐT xác thực</h3>
                <b-form-input v-model="verification" :disabled="verificationMethod==='0' ||modalType==='view'"
                              :state="errors.length > 0 ? false : null" placeholder="Nhập email/sđt dùng để xác thực"
                              size="sm1"/>
                <small v-if="errors.length>0" class="text-danger">Vui lòng Nhập email/sđt dùng để xác thực</small>
              </validation-provider>
            </b-col>
          </div>
        </b-col>
        <b-col class="p-0" cols="6">
          <div class="d-flex pb-1">
            <b-col class="pl-0">
              <h3 style="color: #000000;">Sử dụng code ngẫu nhiên</h3>
              <b-form-checkbox v-model="randomCode" :disabled="modalType==='view'" name="check-button" switch
                               @update="makeid"/>
            </b-col>
            <b-col class="pb-2">
              <h3 style="color: #000000;">Hoạt động</h3>
              <b-form-checkbox v-model="isActive" name="check-button" switch/>
            </b-col>
          </div>
          <h3 style="color: #000000; margin-top: -22px;">Thời gian áp dụng <span class='text-danger'>*</span></h3>
          <div class="d-flex mb-4">
            <b-col class="pl-0">
              <label>Từ ngày</label>
              <b-form-datepicker
                  v-model="startDate"
                  :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                  :disabled="modalType==='view'"
                  locale="vi-VN"
              />
            </b-col>
            <b-col class="pl-0">
              <label>Đến ngày</label>
              <b-form-datepicker
                  v-model="endDate"
                  :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                  :disabled="modalType==='view'"
                  locale="vi-VN"
              />
            </b-col>
          </div>
          <div class="d-flex" style="margin-top: 72px;">
            <b-col class="pb-2 pl-0">
              <h3 style="color: #000000;">Sản phẩm áp dụng <span class='text-danger'>*</span></h3>
              <multiselect
                  v-model="applicableList"
                  :disabled="modalType==='view'"
                  :multiple="true"
                  :options="selectedData.categories"
                  :show-labels="false"
                  label="Name"
                  placeholder="Sản phẩm áp dụng"
                  track-by="Id"
              ></multiselect>
            </b-col>
            <b-col class="pb-2 pl-0">
              <h3 style="color: #000000;">Kênh <span class='text-danger'>*</span></h3>
              <multiselect
                  v-model="channelList"
                  :close-on-select="true"
                  :disabled="modalType==='view'"
                  :multiple="true"
                  :options="[{id:'1',text:'Web'}]"
                  :show-labels="false"
                  label="text"
                  placeholder="Kênh"
                  track-by="id"
              />
            </b-col>
          </div>
          <div class="d-flex">
            <b-col class="pb-2 pl-0">
              <validation-provider #default="{ errors }" :rules="discountType==1?'required':''">
                <h3 style="color: #000000;">Giá trị giảm tối đa</h3>
                <b-form-input v-model="maxDiscount"
                              :disabled="modalType=== 'view' || (discountType==0 && (modalType=== 'edit' || modalType ==='create')) "
                              :state="errors.length > 0 ? false : null" placeholder="Nhập giá trị tối đa được giảm" size="sm1"
                              type="number"/>
                <small v-if="errors.length>0" class="text-danger">Vui lòng Nhập giá trị tối đa được giảm</small>
              </validation-provider>
            </b-col>
            <b-col class="pb-2 pl-0">
              <validation-provider #default="{ errors }" rules="required">
                <h3 style="color: #000000;">Số lần áp dụng/sđt</h3>
                <b-form-input v-model="maxUsagePerSub" :disabled="modalType==='view'" placeholder="Nhập số" size="sm1"
                              type="number"/>
              </validation-provider>
            </b-col>
          </div>
          <div class="d-flex">
            <b-col class="pl-0">
              <h3 style="color: #000000; margin-top: 32px;">Thanh toán</h3>
              <multiselect
                  v-model="paymentMethod"
                  :close-on-select="true"
                  :disabled="modalType==='view'"
                  :multiple="true"
                  :options="paymentMethodList"
                  :show-labels="false"
                  label="text"
                  placeholder="Thanh toán"
                  track-by="id"
              />
            </b-col>
          </div>

        </b-col>
        <b-col class="pl-0 mb-2" cols="12">
          <h3 style="color: #000000;">Thông điệp <span class='text-danger' style="font-size: 14px;">*Không áp dụng chung với các CTKM khác*</span>
          </h3>
          <b-form-textarea v-model="message" :disabled="modalType==='view'" placeholder="Nhập thông điệp" rows="3"/>
        </b-col>
        <b-row v-if="modalType==='view'" class="px-1">
          <h2>Lịch sử dùng mã</h2>
          <b-col class="p-0" cols="12">
            <table class="table table-bordered table-striped table-sm mt-2">
              <thead>
              <th class="text-center">STT</th>
              <th class="text-center">Thời gian sử dụng</th>
              <th class="text-center">Mã đơn hàng</th>
              <th class="text-center">Giá trị giảm</th>
              <th class="text-center">Giá trị đơn hàng</th>
              <th class="text-center">Kênh</th>
              <th class="text-center">Trạng thái sử dụng</th>
              </thead>
              <tbody>
              <tr v-for="(i,index) in historyVoucher" :key="index">
                <td class="text-center">{{ index + 1}}</td>
                <td class="text-center">{{ i.CreateDate }}</td>
                <td class="text-center">{{ i.Id }}</td>
                <td class="text-center">{{ i.DiscountAmount }}</td>
                <td class="text-center">{{ i.TotalPrice }}</td>
                <td class="text-center">{{ i.CreateFrom }}</td>
                <td class="text-center">{{ i.StatusName }}</td>
              </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-row>
      <div class="modal-footer">
        <button v-if="modalType==='view'" class="btn btn-success" data-dismiss="modal" type="button"
                @click="$bvModal.hide('popupCreateDiscount')">Xuất Excel
        </button>
        <button :class="modalType==='view'?'btn-primary':'btn-secondary'" class="btn " data-dismiss="modal"
                type="button" @click="$bvModal.hide('popupCreateDiscount')">Đóng
        </button>
        <button v-if="modalType=='view' && (currentVoucher.status=='Đang diễn ra'|| currentVoucher.status=='Chưa diễn ra' || currentVoucher.status=='Dừng hoạt động' || currentVoucher.status=='Chưa hoạt động')" class="btn btn-primary"
                type="button"
                @click="getDiscountCode">Lưu
        </button>
        <button v-if="modalType!=='view'" class="btn btn-primary" type="button" @click="getDiscountCode">
          {{modalType==='edit'?'Lưu':'Tạo'}}
        </button>
      </div>
    </b-modal>
  </b-card>
</template>
<script>
import Multiselect from 'vue-multiselect'
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {
  BAvatar,
  BButton,
  BCalendar,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BImg,
  BLink,
  BMedia,
  BMediaAside,
  BMediaBody,
  BModal,
  BProgress,
  BRow,
  BTab,
  BTabs,
  BTooltip,
  VBTooltip
} from "bootstrap-vue";
import {required} from "@validations";
import VuePdfApp from "vue-pdf-app";
import {VueGoodTable} from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import "vue-pdf-app/dist/icons/main.css";
import useJwt from "@/auth/jwt/useJwt";
import Select2 from "v-select2-component";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import {kFormatter} from "@core/utils/filter";
import VueApexCharts from "vue-apexcharts";
import StatisticCardVertical from "@core/components/statistics-cards/StatisticCardVertical.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import {PolarArea} from "vue-chartjs";
import 'vue-good-table/dist/vue-good-table.css'
import moment from "moment";

export default {
  components: {
    Multiselect,
    BCalendar,
    BFormCheckbox,
    BFormTextarea,
    BProgress,
    PolarArea,
    AppTimeline,
    BFormDatepicker,
    AppTimelineItem,
    StatisticCardHorizontal,
    StatisticCardVertical,
    VueApexCharts,
    BFormInput,
    BMedia,
    BMediaAside,
    ValidationObserver,
    VueGoodTable,
    BFormSelect,
    ValidationProvider,
    BAvatar,
    BFormGroup,
    BModal,
    BMediaBody,
    BLink,
    BImg,
    BCardHeader,
    BButton,
    BCardBody,
    BCardTitle,
    kFormatter,
    BDropdown,
    BDropdownItem,
    Ripple,
    BRow,
    BCol,
    VuePdfApp,
    Select2,
    BCard,
    flatPickr,
    BTab,
    BCardText,
    BTabs,
    FeatherIcon,
    VBTooltip,
    BTooltip
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mounted() {
    this.getDiscountCodeList();
    this.getDataSelected();
  },
  watch: {
    serverParams: {
      handler: function (newVal, oldVal) {
        this.getDiscountCodeList();
      },
      deep: true,
    },
  },
  data() {
    return {
      historyVoucher: [],
      checked: true,
      required,
      isLoading: false,
      totalRecords: 0,
      rows: [],
      fields: [
        {
          field: "completedCode",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Mã giảm giá",
        },
        {
          field: "campaign_name",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Tên chương trình",
        },
        {
          field: "status",
          filterOptions: {
            enabled: true,
            placeholder: "",
            filterDropdownItems: [
              {value: 'Đang diễn ra', text: "Đang diễn ra"},
              {value: 'Chưa diễn ra', text: "Chưa diễn ra"},
              {value: 'Đã kết thúc', text: "Đã kết thúc"},
              {value: 'Chưa hoạt động', text: "Chưa hoạt động"},
              {value: 'Dừng hoạt động', text: "Dừng hoạt động"},
            ],
          },
          label: "Trạng thái",
          width: "140px"
        },
        {
          field: "discount_type_name",
          filterOptions: {
            enabled: true,
            placeholder: "",
            filterDropdownItems: [
              {value: 0, text: "Giảm theo số tiền"},
              {value: 1, text: "Giảm theo phần trăm"},
            ],
          },
          label: "Loại",
          width: "140px"
        },
        {
          field: "applicableName",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Sản phẩm áp dụng",
        },
        {
          field: "max_discount",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Giá trị giảm tối đa",
        },
        {
          field: "min_order",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Giá trị đơn tối thiểu",
        },
        {
          field: "max_usage_per_sub",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Số lần áp dụng/sđt",
        },
        {
          field: "usedAmount",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Đã dùng",
        },
        {
          field: "amount",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Tổng",
        },
        {
          field: "budgetSpent",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Ngân sách đã chi",
        },
        {
          field: "channelName",
          filterOptions: {
            enabled: true,
            placeholder: "",
            filterDropdownItems: [
              {value: 'Web', text: "Web"},
            ],
          },
          label: "Kênh",
        },
        {
          field: "start_date",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Thời gian bắt đầu",
          width: "100px"
        },
        {
          field: "end_date",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Thời gian kết thúc",
          width: "100px"
        },
        {
          field: "create_by",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Người tạo",
          width: "100px"
        },
        {field: "action", label: "Thao tác",},
      ],
      statisticsOrder: {
        chartOptions: {
          chart: {
            type: "bar",
            toolbar: {
              show: false,
            },
            zoom: {
              enabled: false,
            },
          },
        },
        series: [
          {
            data: [1, 2, 3, 4],
          },
        ],
      },
      serverParams: {
        columnFilters: {
          type: 0,
          end_date: null,
          start_date: null,
        },
        page: 1,
        pageSize: 50,
        sortBy: {},
        sort: []
      },
      campaignCode: null,
      discountType: null,
      discountAmount: null,
      minOrder: null,
      maxDiscount: null,
      usageMethod: null,
      maxUsagePerSub: null,
      partnerCode: null,
      collaboratorCode: null,
      isActive: true,
      campaignName: null,
      startDate: moment(new Date()).format('YYYY-MM-DD'),
      endDate: moment(new Date()).format('YYYY-MM-DD'),
      amount: null,
      verificationMethod: '0',
      verification: null,
      appointedUser: null,
      applicableList: [],
      channelList: [],
      deliveryMethod: [],
      deliveryMethodList: [
        {id: '0', text: 'Tất cả'},
        {id: '1', text: 'Giao hàng tiết kiệm'},
        {id: '2', text: 'Giao hàng hỏa tốc'},
        {id: '3', text: 'Phòng giao dịch'},
      ],
      paymentMethod: [],
      paymentMethodList: [
        {id: '0', text: 'Tất cả'},
        {id: '1', text: 'VNPAY'},
        {id: '2', text: 'ZaloPay'},
        {id: '3', text: 'MOMO'},
        {id: '4', text: 'COD'},
        {id: '5', text: 'VietQR'},
      ],
      message: null,
      selectedData: {
        categories: [], users: []
      },
      modalType: "",
      currentVoucher: {},
      randomCode: null,
      customization: false,
    }
  },
  created() {
    // this.getDiscountCode()
  },
  methods: {
    async onPerPageChange(params) {
      this.serverParams.pageSize = params.currentPerPage
    },
    async onPageChange(params) {
      this.serverParams.page = params.currentPage
    },
    formatPartnerCode(e) {
      if (!/[A-Za-z]$/.test(e)) {
        return;
      }
      return String(e).substring(0, 3);
    },
    formatCampaignCode(e) {
      return String(e).substring(0, 2);
    },
    makeid(length) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const charactersLength = characters.length;
      let counter = 0;
      while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
      }
      return result;
    },
    clearForm() {
      this.randomCode = null
      this.campaignCode = null;
      this.discountType = null;
      this.discountAmount = null;
      this.minOrder = null;
      this.maxDiscount = null;
      this.usageMethod = null;
      this.maxUsagePerSub = null;
      this.partnerCode = null;
      this.collaboratorCode = null;
      this.isActive = true;
      this.campaignName = null;
      this.startDate = null;
      this.endDate = null;
      this.amount = null;
      this.verificationMethod = '0';
      this.verification = null;
      this.appointedUser = null;
      this.applicableList = [];
      this.channelList = [];
      this.deliveryMethod = [{id: '0', text: 'Tất cả'}];
      this.paymentMethod = [{id: '0', text: 'Tất cả'}];
      this.message = null;
    },
    getDiscountCode(bvModalEvt) {
      bvModalEvt.preventDefault()
      // if(this.startDate< moment(new Date()).format('YYYY-MM-DD')|| this.endDate< moment(new Date()).format('YYYY-MM-DD')){
      //   this.$toast({
      //               component: ToastificationContent,
      //               props: {title: 'Thời gian bắt đầu lớn hơn ngày hôm nay', icon: 'AlertTriangleIcon', variant: 'danger'}
      //             })
      //   return;
      // }
      // if(this.startDate>this.endDate){
      //   this.$toast({
      //               component: ToastificationContent,
      //               props: {title: 'Ngày bắt đầu phải nhỏ hơn ngày kết thúc ', icon: 'AlertTriangleIcon', variant: 'danger'}
      //             })
      //   return;
      // }
      let paymentMethods = []
      this.paymentMethod.forEach(e => {
        paymentMethods.push(parseInt(e.id));
      })
      let applicableLists = []
      this.applicableList.forEach(e => {
        applicableLists.push(e.Id);
      })
      let deliveryMethods = []
      this.deliveryMethod.forEach(e => {
        deliveryMethods.push(parseInt(e.id));
      })
      let channelLists = []
      this.channelList.forEach(e => {
        channelLists.push(parseInt(e.id));
      })
      if (this.modalType === 'create') {
        useJwt.post('voucher/create', {
          voucherType: 0,
          campaignCode: this.campaignCode,
          discountType: parseInt(this.discountType),
          discountAmount: parseInt(this.discountAmount),
          minOrder: parseInt(this.minOrder),
          maxDiscount: parseInt(this.maxDiscount),
          usageMethod: parseInt(this.usageMethod),
          applicableList: applicableLists,
          maxUsagePerSub: parseInt(this.maxUsagePerSub),
          partnerCode: this.partnerCode,
          collaboratorCode: this.collaboratorCode,
          isActive: this.isActive ? 1 : 0,
          campaignName: this.campaignName,
          startDate: this.startDate,
          endDate: this.endDate,
          amount: parseInt(this.amount),
          channelList: channelLists,
          verificationMethod: parseInt(this.verificationMethod),
          verification: this.verification,
          appointedUser: this.appointedUser,
          deliveryMethod: deliveryMethods,
          paymentMethod: paymentMethods,
          randomCode: this.randomCode ? this.makeid(5) : null,
          message: this.message,
        })
            .then(response => {
              this.$bvModal.hide('popupCreateDiscount')
              this.getDiscountCodeList();
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Tạo mã giảm giá thành công!', icon: 'CheckSquareIcon', variant: 'success'}
              })
            })
            .catch(error => {
              console.log(error);
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Có lỗi xảy ra vui lòng thử lại', icon: 'AlertTriangleIcon', variant: 'danger'}
              })
            })
      } else {
        useJwt.put('voucher/update/' + this.currentVoucher.id, {
          voucherType: 0,
          campaignCode: this.campaignCode,
          discountType: parseInt(this.discountType),
          discountAmount: parseInt(this.discountAmount),
          minOrder: parseInt(this.minOrder),
          maxDiscount: parseInt(this.maxDiscount),
          usageMethod: parseInt(this.usageMethod),
          applicableList: applicableLists,
          maxUsagePerSub: parseInt(this.maxUsagePerSub),
          partnerCode: this.partnerCode,
          collaboratorCode: this.collaboratorCode,
          isActive: this.isActive ? 1 : 0,
          campaignName: this.campaignName,
          startDate: this.startDate,
          endDate: this.endDate,
          amount: parseInt(this.amount),
          channelList: channelLists,
          verificationMethod: parseInt(this.verificationMethod),
          verification: this.verification,
          appointedUser: this.appointedUser,
          deliveryMethod: deliveryMethods,
          paymentMethod: paymentMethods,
          randomCode: this.randomCode ? this.makeid(5) : null,
          message: this.message,
        })
            .then(response => {
              this.$bvModal.hide('popupCreateDiscount')
              this.getDiscountCodeList();
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Cập nhật mã giảm giá thành công!', icon: 'CheckSquareIcon', variant: 'success'}
              })
            })
            .catch(error => {
              console.log(error);
              this.$toast({
                component: ToastificationContent,
                props: {title: 'Có lỗi xảy ra vui lòng thử lại', icon: 'AlertTriangleIcon', variant: 'danger'}
              })
            })
      }

    },
    openModal(type) {
      this.modalType = type
      this.$bvModal.show('popupCreateDiscount')
    },
    getDiscountCodeList() {
      this.isLoading = true;
      useJwt.post('voucher/list', this.serverParams).then(res => {
        this.rows = res.data.result
        this.totalRecords = res.data.totalRecords;
        this.isLoading = false;
      }).catch(err => {
        console.log(err)
        this.isLoading = false;
      })
    },
    onColumnFilter(params) {
      this.updateParams(params.columnFilters);
    },
    updateParams(newProps) {
      let newServerParamsFilter = {...this.serverParams.columnFilters, ...newProps};
      this.serverParams = Object.assign({}, this.serverParams, {columnFilters: newServerParamsFilter});
    },
    getDataSelected() {
      useJwt.get('voucher/data').then(res => {
            this.selectedData = res.data.result
            this.selectedData.usersSelected = []
            this.selectedData.users.forEach(e => {
              this.selectedData.usersSelected.push({
                id: e.ID,
                text: e.ID
              })
            })
          }
      ).catch(err => {
        console.log(err)
      })
    },
    getHistoryVoucher() {
      this.isLoading = true;
      useJwt.get('voucher/usage/' + this.currentVoucher.completedCode).then(res => {
        this.historyVoucher = res.data.result
        this.isLoading = false;
      }).catch(err => {
        console.log(err)
        this.isLoading = false;
      })
    },
    GetVoucherInfo(voucher, type) {
      this.clearForm()
      this.currentVoucher = voucher
      this.paymentMethod = []
      this.deliveryMethod = []
      this.applicableList
      useJwt.get('voucher/?id=' + voucher.id).then(res => {
        console.log(res.data.result)
        res.data.result.payment_method.split(',').forEach(e => {
          this.paymentMethodList.forEach(method => {
            if (method.id == e) {
              this.paymentMethod.push(method)
            }
          })
        })
        res.data.result.delivery_method.split(',').forEach(e => {
          this.deliveryMethodList.forEach(method => {
            if (method.id == e) {
              this.deliveryMethod.push(method)
            }
          })
        })
        res.data.result.applicable_list.split(',').forEach(e => {
          this.selectedData.categories.forEach(method => {
            if (method.Id == e) {
              this.applicableList.push(method)
            }
          })
        })
        this.campaignCode = res.data.result.campaign_code
        this.discountType = res.data.result.discount_type ? 1 : 0
        this.discountAmount = res.data.result.discount_amount
        this.minOrder = res.data.result.min_order
        this.maxDiscount = res.data.result.max_discount
        this.usageMethod = res.data.result.usage_method ? 1 : 0
        this.maxUsagePerSub = res.data.result.max_usage_per_sub
        this.partnerCode = res.data.result.partner_code
        this.collaboratorCode = res.data.result.collaborator_code
        this.isActive = res.data.result.is_active
        this.amount = res.data.result.amount
        this.campaignName = res.data.result.campaign_name
        this.startDate = res.data.result.start_date
        this.endDate = res.data.result.end_date
        this.verificationMethod = res.data.result.verification_method
        this.verification = res.data.result.verification
        this.appointedUser = res.data.result.appointed_user
        this.channelList = [{id: '1', text: 'Web'}]
        this.message = res.data.result.success_message
        this.getHistoryVoucher()
        this.openModal(type)
      }).catch(err => {
        console.log(err)
      })
    },
  },
};

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";

.vgt-responsive {
  height: 700px;
}

.vgt-table {
  border-collapse: separate !important;
  border-spacing: 0
}

.vgt-table thead {
  position: sticky;
  top: 0px;
  background-color: white;
  z-index: 10
}

span.select2-selection__clear {
  padding-right: 15px;
  font-size: 20px;
}

.b-form-btn-label-control.form-control > .dropdown-menu {
  z-index: 1000;
}

[dir] .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #1FED27;
  background-color: #1FED27 !important;
}

.center-chart {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

.modal-title {
  font-size: 24px;
}

.form-control {
  background-color: #FFF !important;
}

.multiselect__tag-icon:after {
  color: #FFF !important;
}

.multiselect__option--highlight,
.multiselect__tag,
.multiselect__tag-icon:hover {
  background: #ed1f24 !important;
}
</style>
